// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles(() => ({
  brandBadgesContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  splashBadge: {
    marginLeft: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
  },
  arrowCircle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '36px',
    height: '36px',
    backgroundColor: '#F1F3F5',
    borderRadius: '50%',
    border: '4px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
}));

export default useStyles;
